import {
  SET_SINGLE_JOB,
  SET_PRODUCT_EVALUATION,
  SET_RECEIVED_PRODUCT,
  SET_STRIP_OBSERVATION,
  SET_TECHNICAL_INVESTIGATION,
  SET_CONFORMITY_TEST,
  SET_MATERIAL_NUMBER_OPTIONS,
  CLEAR_MATERIAL_NUMBER_OPTIONS,
  SET_INITIAL_WARRANTY_CODE_OPTIONS,
  SEARCHED_TEAM_MEMBERS,
  CLEAR_JOB,
  DELETE_SINGLE_JOB,
} from '../constants/actionTypes';

const initialState = {
  deleted: false,
  searchedMembers: null,
  sections: {},
  materialNumberOptions: null,
  initialWarrantyCodeOptions: null,
};

const singleJob = (state = initialState, action) => {
  switch (action.type) {
    case SET_SINGLE_JOB:
      return {...state, ...action.payload};
    case SEARCHED_TEAM_MEMBERS:
      return {...state, searchedMembers: action.payload}
    case SET_RECEIVED_PRODUCT:
      return {...state, sections: {...state.sections, receivedProduct: action.payload}}
    case SET_PRODUCT_EVALUATION:
      return {...state, sections: {...state.sections, productEvaluation: action.payload}}
    case SET_STRIP_OBSERVATION:
      return {...state, sections: {...state.sections, stripObservation: action.payload}}
    case SET_TECHNICAL_INVESTIGATION:
      return {...state, sections: {...state.sections, technicalInvestigation: action.payload}}
    case SET_CONFORMITY_TEST:
      return {...state, sections: {...state.sections, conformityTest: action.payload}}
    case SET_MATERIAL_NUMBER_OPTIONS:
      return {...state, materialNumberOptions: action.payload};
    case SET_INITIAL_WARRANTY_CODE_OPTIONS:
      return {...state, initialWarrantyCodeOptions: action.payload};
    case CLEAR_MATERIAL_NUMBER_OPTIONS:
      return {...state, materialNumberOptions: null};
    case DELETE_SINGLE_JOB:
      return {...state, deleted: true};
    case CLEAR_JOB:
      return initialState;
    default:
      return state;
  }
}

export default singleJob;



// WEBPACK FOOTER //
// ./src/reducers/reducer-singleJob.js